<div class="text has-text-left">
    <modal [title]="title" [tagEventImp]="tagEventImp" [tagEventCTA]="tagEventCTA" [tagEventClose]="tagEventClose">
        <p class="text">{{ body }}</p>
        <div class="is-flex is-justified-end">
            <button class="button is-conversion mt-2" (click)="redirect()">Voir les autres offres Box internet</button>
        </div>
    </modal>
</div>
